export default class Literal {
	constructor() {
		this.language = new String();
		this.texto = new String();
	}
}
